import { generateSkinDefaults } from '@wix/editor-elements-panel';
import { stylableButtonSkinDefinitionMap } from '../../StylableButton/StylableButton.skinParams';
import { Skins } from '../constants';

export const slideshowButtonSkinDefinition = {
  [Skins.slideshowButton]:
    stylableButtonSkinDefinitionMap['wixui.skins.StylableButton'],
};

export default generateSkinDefaults(slideshowButtonSkinDefinition);
